import React, { Component, Suspense, lazy } from "react";
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import classes from "./Review.scss";
import Summary from '../../components/Flight/FlightSummary/FlightSummary';
import FareAlert from '../../components/FareAlert/FareAlert';
import SessionTimeout from '../../components/SessionTimeout/SessionTimeout';
import Overlay from '../../components/UI/Overlay/Overlay';
import NavigationProgress from "../../components/NavigationProgress/NavigationProgress";
import Spinner from '../../components/UI/Spinner/Spinner';
import SwitchWithSlide from '../../containers/SwitchWithSlide/SwitchWithSlide';

import HeadingH4 from '../../components/UI/Headings/HeadingH4/HeadingH4';
import Media from 'react-media';
import ButtonProceedMobile from '../../components/UI/Button/ButtonProceedMobile/ButtonProceedMobile';
import Button from '../../components/UI/Button/Button';

import * as uiActions from '../../store/actions/index';
import * as farePriceActions from '../../store/actions/index';
import * as paymentActions from '../../store/actions/index';

import fareBreakupIcon from '../../assets/images/farebreakup-icon.svg';
import errorImage from '../../assets/images/no-flights-found.png';
import Article from '../../containers/Article/Article';
import HeadingH3 from "../../components/UI/Headings/HeadingH3/HeadingH3";

const Passengers  = lazy(() => import('../Passengers/Passengers'));
const Addons = lazy(() => import('../../components/Addons/Addons'));
const Payments = lazy(() => import('../Payments/Payments'));

class Review extends Component {
  secondsRemaining;
  intervalHandle;

  state = {
    markupInput: 0,
    markupAmount: 0,
    isAgentProfit: false,
    isSetMarkup: false,
    timeoutID: null,
    minutes: '',
    seconds: '00'
  }

  setMarkupHandler = () => {
    if(parseFloat(this.state.markupInput, 10) < 0) {
      return;
    } 
    this.setState({
      markupAmount: this.state.markupInput,
      isSetMarkup: false
    })
  }

  toggleSetMarkupHandler = () => {
    this.setState(prevState => {
        return { isSetMarkup: !prevState.isSetMarkup  }
    });
  }

  resetMarkupHandler = () => {
    this.setState({
      markupAmount: 0,
      isSetMarkup: false,
      markupInput: 0
    })
  }

  componentWillMount() {
    if (!(this.props.location.pathname.indexOf('details') !== -1)) {
      this.props.history.push({
        pathname: "/reviews/details",
        search: this.props.location.search
      })
    }
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);

    const lob = params.get("lob");
    if(lob && lob === "hotel") {
      this.props.onGetHotelReviewDetails(this.props.location.search);
    } else {
      const flightCode = params.get("flightCode") || "";

      if (flightCode) {
        this.props.onGetFarePrice(params, params.get("flightIdCSV"), params.get("flightCode"), params.get("isInt"));
      }
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.timeoutTime !== this.props.timeoutTime) {
      this.setState({
        minutes: this.props.timeoutTime
      }, () => {
        this.intervalHandle = setInterval(this.tick, 1000);
        let time = this.state.minutes;
        this.secondsRemaining = time * 60;
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalHandle);
  }

  tick = () => {
    let min = Math.floor(this.secondsRemaining / 60);
    let sec = this.secondsRemaining - (min * 60);

    this.setState({
      minutes: min,
      seconds: sec
    });

    if (sec < 10) {
      this.setState({
        seconds: "0" + this.state.seconds,
      })
    }

    if (min < 10) {
      this.setState({
        minutes: "0" + min,
      })
    }

    if (min === 0 & sec === 0) {
      clearInterval(this.intervalHandle);
    }

    this.secondsRemaining--;
  }

  inputChangeHandler = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({ [name]: value });
  }

  payButtonHandler = (dispAmount) => {
    const params = new URLSearchParams(this.props.location.search);
    let mealAmount = 0;
    let baggageAmount = 0;
    let seatsAmount = 0;
    const mealAddon = this.props.addonList.filter(addon => addon.addonLabel === "Meals");
    const baggageAddon = this.props.addonList.filter(addon => addon.addonLabel === "Baggage");
    const seatsAddon = this.props.addonList.filter(addon => addon.addonLabel === "Seats");

    if(mealAddon.length > 0) {
      mealAmount = mealAddon[0].amount;
    }
    if(baggageAddon.length > 0) {
      baggageAmount = baggageAddon[0].amount;
    }
    if(seatsAddon.length > 0) {
      seatsAmount = seatsAddon[0].amount;
    }

    let gstDetails = {};

    if(this.props.gstNumber && this.props.email && this.props.companyName && this.props.mobileNumber) {
      gstDetails = {
        isApplied: "true",
        gstEmailId: this.props.gstEmail,
        gstMobileNo: this.props.mobileNumber,
        gstCompanyName: this.props.companyName,
        gstCompanyAddress: "",
        gstNumber: this.props.gstNumber,
        gstCity: "",
      }
    }

    let booking = {
          globalParams: {
            prq: "",
            creator: "",
            pricingId: this.props.pid,
            searchId: this.props.searchId,
            superPnr: this.props.superPnr,
            channel: "b2b",
            product: "flight",
            url: this.props.pricingUrl,
            ftype: this.props.ftype,
            org: this.props.org,
            dest: this.props.dest,
            changeFlightUrl: this.props.changeFlightUrl,
            isPartial: false,
            ebs_accountId: this.props.ebs_accountId,
            ebs_sessionId: this.props.ebs_sessionId,
            rurl: 'https://secure.yatra.com/quicksilvercontroller/payment/checkPaymentStatus',
            // rurl: 'http://localhost:3000/payment/checkPaymentStatus',
            childTenant: "b2bdom",
            variation: 1,
            // moProfileType: this.props.moProfileType
          },
          addOnParams: this.props.addonList,
          hotelCrossSellParams: {
            isHotelCrosssellBooking: false,
            hotelBookingRequestJSON: ""
          },
          productParams: {
            tripType: this.props.ftype,
            amountDisp: dispAmount,
            displayMarkup: this.state.markupAmount
          },
          promoParams: {
            status: false,
            promoCode: "",
            isReadonly: false,
            amount: 0,
            ecashAmount: 0,
            promoType: "",
            msg: "",
            authCode: "",
            category: "",
            disableYlp: false
          },
          userParams: {
            additionalContact: {
              email: this.props.email,
              mobile: this.props.mobile,
              mobileISD: "91"
            },
            emailId: this.props.email,
            mobileNo: this.props.mobile,
            userId: "undefined",
            title: "",
            firstName: "",
            lastName: "",
            mobileNoISD: "91"
          },
          travellerParams: [],
          gstDetails: gstDetails,
          discountParams: {},
          totalBreakup: {
            meals: {
              amount: mealAmount,
              label: "Meals"
            },
            baggage: {
              amount: baggageAmount,
              label: "Baggage"
            },
            seats: {
              amount: seatsAmount,
              label: "Seats"
            },
            others: {
              amount: 0,
              label: "Others Charges"
            },
            insurance: {
              amount: 0,
              label: "Travel Assistance"
            },
            "save.child": {
              amount: 0,
              label: "TAKE OFF Contribution"
            },
            SDFC: {
              amount: 0,
              label: "Same Day Cancellation Protection"
            },
            DFC: {
              amount: 0,
              label: "Cancellation Protection"
            },
            BBG: {
              amount: 0,
              label: "Best buy Assurance"
            },
            beingHuman: {
              amount: 0,
              label: "Being Human Contribution"
            },
            matrix: {
              amount: 0,
              label: "MATRIX Calling Card"
            },
            markup: {
              amount: this.state.markupAmount,
              label: "Markup"
            }
          },
          advancedPricing: {
            
          },
          upSellParams:[  
            {  
               type:"regular",
               id: this.props.flightCode,
               rph:"",
               sequence:"1"
            }
         ],  
        }
    
    booking['travellerParams'] = this.props.passengers;

    // let profileType = Object.keys(this.props.userProfile.moDetail)[0];
    // let travellerSSOId = this.props.userProfile.moDetail[profileType].clientID;

    const paymentObject = {
      "product": "b2bdom",
      "servicesRequested": ["paymentOptionJSON","bookingDetails","balance"],
      // "agentProfileType": profileType,
      "merchant": "yatra",
      "superPnr": this.props.superPnr,
      "ssoToken": localStorage.getItem('ssoToken'),
      // "travellerSSOId": travellerSSOId,
      "uuid": this.props.pid,
      "pricingId": this.props.pid
    }

    this.props.onSaveReviewDetails({
      isInt: params.get("isInt"),
      pricingId: this.props.pid,
      superPnr: this.props.superPnr,
      reviewJson: JSON.stringify(booking)
    }, paymentObject);
    this.props.history.push({
      pathname: "/reviews/pay",
      search: this.props.location.search
    })
  }

  render() {
    let primaryContainer = null;
    let secondaryContainer = null;
    let payNowButton = null;
    let summary = <Summary
      inputChangeHandler={this.inputChangeHandler}
      payButtonHandler={this.payButtonHandler}
      fareDetailsOneWay={this.props.fareSummaryOneWay}
      fareDetailsRoundTrip={this.props.fareSummaryRoundTrip}
      addonList={this.props.addonList}
      markupInput={this.state.markupInput}
      markupAmount={this.state.markupAmount}
      isAgentProfit={this.state.isAgentProfit}
      onSetMarkup={this.setMarkupHandler}
      resetClicked={this.resetMarkupHandler}
      isSetMarkup={this.state.isSetMarkup}
      onToggleMarkup={this.toggleSetMarkupHandler}
    />;

    let routePath = this.props.location.pathname;
    const isPathDetails = routePath.indexOf('details') !== -1;
    const isPathAddons = routePath.indexOf('addons') !== -1;
    const isPathPay = routePath.indexOf('pay') !== -1;

    primaryContainer = (
      <Media query="(max-width: 599px)">
        {matches =>
            matches ? 
            <React.Fragment>
              {
                this.props.diff !== 0 && !this.props.hideFareAlert ? <FareAlert/> : 
                <div className={classes.Inner}>
                  {/* <div className="mb-3 phone-pt-0 phone-pb-0 phone-pl-2 phone-pr-2 u-textAlignRight">
                    <span className="u-textAlignRight u-fontSize13 u-textColorPrimary u-cursorPointer u-textUppercase"
                    onClick={() => {
                      this.props.history.push(`/flights/search?${this.props.changeFlightUrl}`);
                    }}>Change Flight</span>
                  </div> */}
                  <Suspense fallback={<div>Loading...</div>}>
                    <SwitchWithSlide>
                      <Route path='/reviews/details' component={Passengers}/>
                      <Route path='/reviews/addons' component={Addons}/>
                      <Route path='/reviews/pay' component={Payments}/>
                    </SwitchWithSlide>
                  </Suspense>
                </div>
              }
            </React.Fragment>
            : 
            <SwitchWithSlide>
              <div className={classes.Inner}>
                <div className="mb-3 phone-pt-0 phone-pb-0 phone-pl-2 phone-pr-2 u-textAlignRight">
                  <span className="u-textAlignRight u-fontSize13 u-textColorPrimary u-cursorPointer u-textUppercase"
                  onClick={() => {
                    this.props.history.push(`/flights/search?${this.props.changeFlightUrl}`);
                  }}>Change Flight</span>
                </div>
                <Suspense fallback={<div>Loading...</div>}>
                    <Route path='/reviews/details' component={Passengers}/>
                    <Route path='/reviews/addons' component={Addons}/>
                    <Route path='/reviews/pay' component={Payments}/>
                </Suspense>
              </div>
            </SwitchWithSlide>
        }
      </Media>
    );

    secondaryContainer = (
      <React.Fragment>
        <Media query="(max-width: 599px)">
          {matches =>
              matches ? 
              summary : 
              this.props.diff !== 0 && !this.props.hideFareAlert && this.secondsRemaining > 0 ? <FareAlert /> 
                : this.secondsRemaining === 0 ? <SessionTimeout url={`/flights/search?${this.props.changeFlightUrl}`} origin={this.props.cityNames[this.props.org]} destination={this.props.cityNames[this.props.dest]} /> 
                : summary
              }
        </Media>
      </React.Fragment>
    )

    let flightTotalPrice = 0;
    const params = new URLSearchParams(this.props.location.search);

    if (this.props.fareSummaryOneWay && !this.props.fareSummaryRoundTrip) {
      flightTotalPrice = Math.round(parseInt(this.props.fareSummaryOneWay.revisedFareDetails.tf, 10));
      payNowButton = <ButtonProceedMobile onClick={() => {
        this.payButtonHandler(Math.round(parseInt(this.props.fareSummaryOneWay.revisedFareDetails.tf, 10) + parseInt(this.state.markupAmount, 10)))
      }} disabled={!this.props.isButtonActive}>Pay Now</ButtonProceedMobile>
    } else if (this.props.fareSummaryOneWay && this.props.fareSummaryRoundTrip) {
      if(params.get("isInt") === "true") {
        flightTotalPrice = Math.round(parseFloat(this.props.fareSummaryOneWay.revisedFareDetails.tf, 10));
      } else {
        flightTotalPrice = Math.round(parseFloat(this.props.fareSummaryOneWay.revisedFareDetails.tf, 10) + parseFloat(this.props.fareSummaryRoundTrip.revisedFareDetails.tf, 10));
      }
      payNowButton = <ButtonProceedMobile onClick={() => {
        this.payButtonHandler(Math.round(parseFloat(this.props.fareSummaryOneWay.revisedFareDetails.tf, 10) + parseFloat(this.props.fareSummaryRoundTrip.revisedFareDetails.tf, 10) + parseInt(this.state.markupAmount, 10)))
      }} disabled={!this.props.isButtonActive}>Pay Now</ButtonProceedMobile>
    }

    return (
      <React.Fragment>
        <div style={{minHeight: isPathPay ? 'calc(100vh - 4.5rem)' : '100vh'}} className={classes.Wrapper}>
          <div style={{
              transform: this.props.flowLogin ? 'translateX(0)' : 'translateX(-36rem)',
              position: 'fixed',
              top: '0',
              left: '0',
              transition: 'all .45s cubic-bezier(.4,0,.2,1)'
            }}>
            <Article/>
          </div>
          {
            this.props.loadingPrimary && !this.props.error ? <Spinner/> : !this.props.loadingPrimary && this.props.error ? <div className={classes.ErrorBox}>
              <div className="mb-4">
                <img src={errorImage} className="u-width100Percent" alt="Error" />
              </div>
              <HeadingH3 size={16} weight="Medium" color="Dark">We are sorry!</HeadingH3>
              <p className="mt-3 mb-3">We could not confirm your flight(s). This might be due to connectivity with airline system. Please select another flight(s).</p>
              <Button theme='Primary' type='Reset' onClick={() => this.props.history.goBack()}>Select Another Flight</Button>
            </div> : <React.Fragment>
              <section className={classes.Primary} style={{ transform: this.props.flowLogin ? 'translateX(36rem)' : 'none' }}>
                <Overlay style={{transform: (this.props.diff !== 0 && !this.props.hideFareAlert) || this.secondsRemaining === 0  ? 'translateX(0%)' : 'translateX(-100%)'}} />
                <div className={`${classes.Navigation} u-phoneHide`}> 
                  <NavigationProgress />
                </div>
                {this.props.loading ? <Spinner/> : primaryContainer}
                  <Media query="(max-width: 900px)">
                        {matches => matches && isPathDetails ? 
                        <div className="u-sticky u-left0 u-bottom0 u-width100Percent u-phoneShow u-zIndex9999">
                          <div className={classes.ProceedContainer} style={{ display: this.props.diff !== 0 && !this.props.hideFareAlert ? 'none' : 'flex' }}>
                            <div>
                              <HeadingH4 size={18} weight="Medium" color="White">You Pay &#8377; {parseInt(flightTotalPrice, 10).toLocaleString()}</HeadingH4>
                              {
                                !this.props.mobileFareBreakup ? <p className={`u-cursorPointer u-fontSize13 u-textColorFluorescentGreen`} onClick={() => this.props.onToggleMobileFareBreakup()}>
                                <img src={fareBreakupIcon} alt='Promo' className={`u-size10x10 mr-1`}/>
                                  Fare Breakup
                                </p> : null
                              }
                            </div>
                            {
                              !this.props.mobileFareBreakup ? <ButtonProceedMobile disabled={!this.props.isContinueButtonActive} count={this.props.paxCounter} onClick={() => this.props.history.push({
                                pathname: "/reviews/addons",
                                search: this.props.location.search
                              })}>Continue</ButtonProceedMobile>
                                : <div className={classes.CloseButton} onClick={() => this.props.onToggleMobileFareBreakup()}>
                                <span>CLOSE</span>
                              </div>
                            }
                          </div>
                          {this.state.minutes > 0 ? <div className="u-height45 u-bottom u-width100Percent u-backgroundColorDark u-textAlignCenter u-textColorWhite u-lineHeight45">
                            <p>Session Expires in {this.state.minutes} : {this.state.seconds}</p>
                          </div> : null}
                        </div>
                         : isPathAddons ? 
                        <div className="u-sticky u-left0 u-bottom0 u-width100Percent u-phoneShow u-zIndex9999">
                          <div className={classes.ProceedContainer}>
                            <div>
                              <HeadingH4 size={18} weight="Medium" color="White">You Pay &#8377; {parseInt(flightTotalPrice, 10).toLocaleString()}</HeadingH4>
                              {
                                !this.props.mobileFareBreakup ? <p className={`u-cursorPointer u-fontSize13 u-textColorFluorescentGreen`} onClick={() => this.props.onToggleMobileFareBreakup()}>
                                <img src={fareBreakupIcon} alt='Fare Breakup' className={`u-size10x10 mr-1`}/>
                                Fare Breakup
                              </p> : null
                              }
                            </div>
                            {
                              !this.props.mobileFareBreakup ? payNowButton : 
                              <div className={classes.CloseButton} onClick={() => this.props.onToggleMobileFareBreakup()}>
                                <span>CLOSE</span>
                              </div>
                            }
                          </div>
                          <div className="u-height45 u-bottom u-width100Percent u-backgroundColorDark u-textAlignCenter u-textColorWhite u-lineHeight45">
                            <p>Session Expires in {this.state.minutes} : {this.state.seconds}</p>
                          </div>
                        </div> : isPathPay ? 
                            <div className="u-sticky u-left0 u-bottom0 u-width100Percent u-phoneShow u-zIndex9999">
                              <div className="u-height45 u-bottom u-width100Percent u-backgroundColorDark u-textAlignCenter u-textColorWhite u-lineHeight45">
                                <p>Session Expires in {this.state.minutes} : {this.state.seconds}</p>
                              </div>
                            </div>
                          : null 
                        }
                  </Media>
              </section>
              <section className={[classes.Secondary, this.props.mobileFareBreakup ? classes.SecondaryMobile : null].join(' ')} style={{
                  transform: this.props.flowLogin ? 'translateX(36rem)' : null,
                  borderLeft: isPathPay ? "none" : '#dee2ed'
                }}>
                {secondaryContainer}     
              </section>
            </React.Fragment>
          }
          {this.secondsRemaining > 0 ? <div className="u-fixed u-phoneHide u-height45 u-bottom0 u-bottom u-left0 u-width100Percent u-backgroundColorDark u-textAlignCenter u-textColorWhite u-lineHeight45">
            <p>Session Expires in {this.state.minutes} : {this.state.seconds}</p>
          </div> : null}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    loadingPrimary: state.farePrice.loadingPrimary,
    mobileFareBreakup: state.ui.mobileFareBreakup,
    addonList: state.farePrice.addonList,
    isValid: state.farePrice.isValid,
    adultCount: state.farePrice.adultCount,
    childCount: state.farePrice.childCount,
    infantCount: state.farePrice.infantCount,
    paxCounter: state.farePrice.paxCounter,
    fareSummaryOneWay: state.farePrice.fareSummaryOneWay,
    fareSummaryRoundTrip: state.farePrice.fareSummaryRoundTrip,
    flowLogin: state.auth.flowLogin,
    isContinueButtonActive: state.farePrice.paxCounter === 0 && state.farePrice.userParams.additionalContact.isEmailValid && state.farePrice.userParams.additionalContact.mobile !== '' && state.farePrice.userParams.additionalContact.mobileISD.trim() !== '' ? true : false,
    isButtonActive: state.farePrice.userParams.additionalContact.isEmailValid && state.farePrice.userParams.additionalContact.mobile !== '' && state.farePrice.userParams.additionalContact.mobileISD.trim() !== '' ? true : false,
    diff: state.farePrice.generalData ? state.farePrice.generalData.diff : 0,
    hideFareAlert: state.ui.hideFareAlert,
    pid: state.farePrice.generalData ? state.farePrice.generalData.pricingId : null,
    searchId: state.farePrice.generalData ? state.farePrice.generalData.data.searchId : null,
    superPnr: state.farePrice.generalData ? state.farePrice.generalData.superPnr : null,
    org: state.farePrice.generalData ? state.farePrice.generalData.data.org : null,
    dest: state.farePrice.generalData ? state.farePrice.generalData.data.dest : null,
    cityNames: state.farePrice.generalData ? state.farePrice.generalData.data.cityNames : null,
    ftype: state.farePrice.generalData ? state.farePrice.generalData.data.ftype : null,
    changeFlightUrl: state.farePrice.generalData ? state.farePrice.generalData.changeFlightUrl : null,
    ebs_accountId: state.farePrice.generalData ? state.farePrice.generalData.data.ebs_accountId : null,
    ebs_sessionId: state.farePrice.generalData ? state.farePrice.generalData.data.ebs_sessionId : null,
    moProfileType: state.farePrice.generalData ? state.farePrice.generalData.data.moProfileType : null,
    email: state.farePrice.userParams.additionalContact.email,
    mobile: state.farePrice.userParams.additionalContact.mobile,
    flightCode: state.flights.flightCode,
    userProfile: state.auth.userProfile,
    passengers: state.farePrice.passengers,
    gstNumber: state.farePrice.gstNumber,
    companyName: state.farePrice.companyName,
    gstEmail: state.farePrice.email,
    mobileNumber: state.farePrice.mobileNumber,
    error: state.farePrice.error,
    sessionTimeoutData: state.farePrice.generalData ? state.farePrice.generalData.sessionTimeoutData : null,
    timeoutTime: state.farePrice.timeoutTime
  }
}

const mapDispatchToProps = dispatch => {
  return {    
    onGetFarePrice: (farePriceParams, flightId, flightCode, isInt) => dispatch(farePriceActions.getFarePrice(farePriceParams, flightId, flightCode, isInt)),
    onToggleMobileFareBreakup: () => dispatch(uiActions.toggleMobileFareBreakup()),
    onSaveReviewDetails: (bookingObject, paymentObject) => dispatch(paymentActions.saveReviewDetails(bookingObject, paymentObject)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Review);



// WEBPACK FOOTER //
// ./src/containers/Review/Review.js